import { createApiRef } from '@backstage/core-plugin-api';
import { TemplateMetrics } from '../../types/metrics';
import { Entity } from '@backstage/catalog-model';

export const metricsApiRef = createApiRef<MetricsApi>({
  id: 'plugin.metrics-alerting-insights.metrics.service',
});

export interface MetricsApi {
  retrieveMetricsInfo: (entity: Entity) => Promise<TemplateMetrics>;
}
